<div class="ps-table-container">
  <header>
    <div class="row ps-table-title-container">
      <div class="col-md-6 col-sm-12">
        @if (grid.getSetting('showTitle')) {
          <div class="ps-table-title" class="ps-table-title">{{grid.getSetting('title')}}</div>
        }
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="ps-table-filter-container">
          @if (grid.getSetting('filter.advancedFilter')) {
            <button type="button"  class="btn btn-primary-clean" (click)="toggleAdvancedFilter()">
              <i class="fa fa-sliders"></i>&nbsp;Advanced Filter
            </button>
          }
          @if (grid.getSetting('filter.quickFilter')) {
            <ps-table-quick-filter [source]="dataSource"></ps-table-quick-filter>
          }
        </div>
      </div>
    </div>
    @if (showAdvancedFilter) {
      <div [ngClass]="{'show': showAdvancedFilter}" class="fade">
        <ng-content select="ps-advanced-filters"></ng-content>
      </div>
    }
  </header>
  <table class="ps-table table" [id]="grid.getSetting('tableId')" [ngClass]="grid.getSetting('tableClass')">
    <thead>
      <tr class="ps-table-headers">
        @for (column of grid.getVisibleColumns(); track column) {
          <th class="ps-table-th {{ column.id }}" [ngClass]="column.columnClass">
            <div class="ps-table-header">
              <ps-table-title [source]="dataSource" [column]="column" (sort)="sort($event)"></ps-table-title>
            </div>
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of grid.getRows(); track row) {
        <tr class="ps-table-row" (click)="onUserSelectRow(row)" (dblclick)="grid.viewAction(row)" [ngClass]="{selected: row.isSelected}">
          @for (cell of row.getCells(); track cell) {
            <td>
              @if (cell.isViewLink()) {
                <button class="btn btn-link" (click)="grid.viewAction(row)" [innerHTML]="cell.getValue()"></button>
              }
              @if (!cell.isViewLink()) {
                <span [innerHTML]="cell.getValue()"></span>
              }
            </td>
          }
        </tr>
        @if (grid.getActions().length > 0) {
          <tr class="ps-table-action-row" [hidden]="!row.isSelected" (dblclick)="grid.viewAction(row)">
            <td [attr.colspan]="grid.getColumns().length" class="text-right">
              @for (action of grid.getActions(row); track action) {
                <button [ngClass]="action.actionClass" class="ps-table-action-link"
                  (click)="action.action(row)">
                  @if (action.iconClass) {
                    <i [ngClass]="action.iconClass"></i>
                  }
                  {{action.name}}
                </button>
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
  @if (grid.getSetting('pager.display')) {
    <ps-table-pager
      [source]="dataSource"
      [perPage]="grid.getSetting('pager.perPage')"
      (changePage)="changePage($event)">
    </ps-table-pager>
  }
</div>

